import { Centralizer } from '@/components';
import { type FC, useState } from 'react';
import { AuthenticationPagesLayout } from '../_components/AuthenticationPagesLayout';
import { RequestOneTimeCodeForm } from '../_components/RequestOneTimeCodeForm';
import { ResetPasswordForm } from '../_components/ResetPasswordForm';

const ResetForgotPasswordPage: FC = () => {
  const [targetUserKey, setTargetUserKey] = useState<string | null>(null);
  const [targetEmailAddress, setTargetEmailAddress] = useState<string | null>(
    null,
  );

  return (
    <AuthenticationPagesLayout>
      <Centralizer>
        {targetUserKey && targetEmailAddress ? (
          <ResetPasswordForm
            targetEmailAddress={targetEmailAddress}
            targetUserKey={targetUserKey}
          />
        ) : (
          <RequestOneTimeCodeForm
            setTargetEmailAddress={setTargetEmailAddress}
            setTargetUserKey={setTargetUserKey}
          />
        )}
      </Centralizer>
    </AuthenticationPagesLayout>
  );
};

export default ResetForgotPasswordPage;
